import { BASE_ROLES } from '../../../core/constants/base-roles';

export const AUTHORITY_ROLES = [BASE_ROLES.CUSTOMER_WORK_COUNCIL, BASE_ROLES.CUSTOMER_ADMIN, BASE_ROLES.PSP_ADMIN];
